import React from 'react';
import { Table, Button, Modal, Header, Grid, Input, Form, Icon, Menu, Dropdown, Dimmer, Loader, Image, Segment, Message    } from 'semantic-ui-react';
import _ from 'underscore';
import { withRouter } from 'react-router';





const ListMSBillingCompanySelection = (props) => { 
    const paginationInfo = `${(props.perPage*props.currentPage)-props.perPage+1}-${(props.perPage*props.currentPage)>props.totalData ? props.totalData : (props.perPage*props.currentPage)} of ${props.totalData}`
    return (
        <Modal open={props.open}>
            <Header style={{ backgroundColor: "#2185d0", color: "#FFFFFF" }}>
                Please select company
                <span style={{display:"inline-block", float:"right", cursor:"pointer"}} onClick={props.onClose}>X</span>
            </Header>
            <Modal.Content>
                <Grid columns="equal">
                    <Grid.Column width={16}> 
                        <Input fluid type='text' placeholder='Search...' action>
                                <input value={props.query} onChange={(e) => props.checkClearFilter(e)} />
                                <Dropdown 
                                    placeholder='Filter by' 
                                    selection options={props.filterOptions}
                                    value={props.filter} 
                                    onChange={props.onFilterDropdownChange} 
                                    />
                                <Button type="submit" color="green" icon="search" content="Search" onClick={props.submitFilter}/>
                                { props.query.length > 0 &&
                                    <Button type="button" color="black" icon="close" content="Clear" onClick={props.clearFilter}/>
                                }
                        </Input>
                    </Grid.Column>
                </Grid>
                {props.isLoading ? 
                        <Segment>
                            <Dimmer active inverted>
                                <Loader inverted content='Loading' />
                            </Dimmer>

                            <Image src='https://react.semantic-ui.com/images/wireframe/short-paragraph.png' />
                        </Segment>:
                        <div>
                            {props.clients.length > 0 &&
                                <Table celled selectable>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Company Name</Table.HeaderCell>
                                        <Table.HeaderCell>Status</Table.HeaderCell>
                                        <Table.HeaderCell>Group Code</Table.HeaderCell>
                                        <Table.HeaderCell>Policy No</Table.HeaderCell>
                                        <Table.HeaderCell></Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>  
                                    {_.map(props.clients, (client) => {  
                                            const {
                                                _id,
                                                companyName,
                                                active,
                                                groupCode,
                                                policyNo
                                            } = client;
                                            return (
                                                <Table.Row key={_id}>
                                                    <Table.Cell>{companyName}</Table.Cell>
                                                    <Table.Cell>{active ? 'Active':'Inactive'}</Table.Cell>
                                                    <Table.Cell>{groupCode}</Table.Cell>
                                                    <Table.Cell>{policyNo}</Table.Cell>
                                                    <Table.Cell>
                                                        <Button onClick={() => { props.onSelectCompany(client) }} fluid>Select</Button>
                                                    </Table.Cell>
                                                </Table.Row>
                                            );
                                        }) 
                                           
                                    }
                                </Table.Body>
                                <Table.Footer>
                                <Table.Row>
                                <Table.HeaderCell colSpan='8'>
                                    <Menu floated='right' pagination>
                                        <Menu.Item as='a' icon onClick={props.goToPreviousPage}
                                            disabled={props.currentPage === 1}>
                                            <Icon name='chevron left'/>
                                        </Menu.Item>
                                        <Menu.Item>{paginationInfo}</Menu.Item>
                                        <Menu.Item as='a' icon onClick={props.goToNextPage}
                                            disabled={props.clients.length < props.perPage}>
                                            <Icon name='chevron right'/>
                                        </Menu.Item>
                                    </Menu>
                                    <Menu floated='right' pagination>
                                        <Menu.Item>Page</Menu.Item>
                                        <Dropdown scrolling item text={props.currentPage.toString()} defaultValue={props.currentPage}>
                                            <Dropdown.Menu>
                                                {[...Array(props.totalPage)].map((e, i) =>
                                                    <Dropdown.Item key={i} onClick={() => props.setPage(i+1)}>{i+1}</Dropdown.Item>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Menu>
                                    <Menu floated='right' pagination>
                                        <Menu.Item>View</Menu.Item>
                                        <Dropdown item text={props.perPage.toString()} defaultValue={props.perPage}>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => props.setPerPage(10)}>10</Dropdown.Item>
                                                <Dropdown.Item onClick={() => props.setPerPage(20)}>20</Dropdown.Item>
                                                <Dropdown.Item onClick={() => props.setPerPage(50)}>50</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Menu>
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                    </Table>}
                    {props.clients.length == 0 && !props.isSearch && <Message success center>
                        <Message.Header>We're sorry, all companies already exist in Groupcare.</Message.Header> 
                    </Message>}
                    {props.clients.length == 0 && props.isSearch && <Message negative center>
                        <Message.Header>Company not found.</Message.Header> 
                    </Message>}
                    </div>
                    }
                
            </Modal.Content>
        </Modal>

    );
}

ListMSBillingCompanySelection.defaultProps = {
    open: true,
    clients: [],
    onSelectCompany: function(){},
    onClose: function(){}
}

export default withRouter(ListMSBillingCompanySelection);